// src/app/core/constants/strings.ts
export abstract class Strings {

    //#region These strings are used during print pdf to print TOP 6 default fields in permit.
    static readonly DefaultPermitNoText='Permit No';
    static readonly DefaultPermitExpiryDateTimeText='Permit Expire Date/Time';
    static readonly DefaultIssueDateTimeText='Permit Issue Date/Time';
    static readonly DefaultPermitAreaText='Area';
    static readonly DefaultPermitRequestorText='Permit Requestor Name';
    static readonly DefaultPermitSiteText='Site';
    //#endregion

    static readonly Identifiers = {
        RoleId: 'RoleId',
        PermitTypeSectionId: 'PermitTypeSectionId',
        ApproverTypeId: 'ApproverTypeId'
    };

    static readonly NumericFlags = {
        Zero: '0',
        One: '1',
        Two: '2'
    };

    static readonly BooleanFlags = {
        False: 'false'
    };
}